import { useEffect, useRef, useState } from 'react';

interface Options {
    defaultValue?: number;
    ResizeObserver?: typeof window.ResizeObserver;
}

export const useElementSize = (
    ref: HTMLElement | HTMLDivElement | null | undefined,
    type:
        | 'scrollHeight'
        | 'clientHeight'
        | 'offsetHeight'
        | 'scrollWidth'
        | 'clientWidth'
        | 'offsetWidth',
    options?: Options,
) => {
    const { defaultValue = 0, ResizeObserver = window.ResizeObserver } = options || {};
    const [size, setSize] = useState(defaultValue);
    const requestRef = useRef<number>();

    useEffect(() => {
        if (!ref) {
            setSize(defaultValue);

            return;
        }

        const resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
            requestRef.current = window.requestAnimationFrame(() => {
                const newSize = (entries[0].target as HTMLElement)[type];
                setSize(newSize);

                return newSize;
            });
        });

        resizeObserver.observe(ref);

        return () => {
            resizeObserver.disconnect();
            if (requestRef.current) {
                cancelAnimationFrame(requestRef.current);
            }
        };
    }, [ref, type, ResizeObserver, defaultValue]);

    return size;
};
